import React, { useEffect } from 'react';

import s from './style.module.css';
import logo from '@Images/logo.webp';
import { backfaceFixed } from '@Util/backfaceFixed';
import { URL } from '@Pages/url';
import LazyableImage from '@Components/lazyable_image/view';
import { isBusinessTime } from '@Util/util';
import OperatorSVGIcon from '@Components/svg_icon/operator';
import FreedialSVGIcon from '@Components/svg_icon/freedial';
import LineInquiry from '@Components/line_inquiry/view';
import { PlusMinus } from '@Components/css_icon/plus_minus';
import TestLabel from '@Components/test_label/view';

type HeaderAccordionGroupKey = 'membership' | 'about';

type HeaderProps = {
    courseId?: string;
    isInquiry?: boolean;
    // SP版Headerは現状getPathResolverを使っていないため未使用（PC版のPage/Headerと型を揃えるために受け取るだけ）
    currentPath?: string;
};

export const Header = (props: HeaderProps) => {
    const [open, setOpen] = React.useState(false);
    const [openGroup, setOpenGroup] = React.useState<HeaderAccordionGroupKey | null>(null);
    const contactUrl = props.courseId ? `${URL.CONTACT}?course_id=${props.courseId}` : URL.CONTACT;

    useEffect(() => {
        backfaceFixed(open);
        if (!open) {
            setOpenGroup(null);
        }
    }, [open]);

    return (
        <>
            <div className={`${s.header} ${props.isInquiry ? s.inquiry_header : ''}`}>
                <TestLabel />
                <div className={s.logo}>
                    <a href='/'>
                        <LazyableImage src={logo} alt='住地ゴルフ' width={136} height={20} />
                    </a>
                </div>
                {props.isInquiry || (
                    <>
                        <div className={`${s.inquiry_button}  ${open ? s.hidden : ''}`}>
                            <a href={contactUrl}>
                                <OperatorSVGIcon className={s.operator_icon} />
                                お問合せ
                            </a>
                        </div>
                        <div className={s.menu}>
                            <div className={`${s.menu_btn} ${open ? s.active : ''}`} onClick={() => setOpen(!open)}>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    </>
                )}
            </div>
            {open ? <div className={s.header_accordion_bg} /> : ''}
            <div className={`${s.header_accordion} ${open ? s.active : ''}`}>
                <a className={s.header_accordion_link} href='/'>
                    ホーム
                </a>
                <HeaderAccordionGroup
                    title='ゴルフ会員権情報'
                    open={openGroup === 'membership'}
                    onToggle={() => setOpenGroup(openGroup === 'membership' ? null : 'membership')}
                >
                    <a className={s.header_accordion_child_link} href={URL.COURSES}>
                        会員権相場検索
                    </a>
                    <a className={s.header_accordion_child_link} href={URL.KNOWLEDGE}>
                        会員権の基礎知識
                    </a>
                    <a className={s.header_accordion_child_link} href={URL.INFO_FEATURED_STAFF_BLOG}>
                        会員権の特集記事
                    </a>
                </HeaderAccordionGroup>
                <a className={s.header_accordion_link} href={URL.CORPORATE}>
                    法人のお客様へ
                </a>
                <a className={s.header_accordion_link} href={URL.MEMBER_VOICES}>
                    お客様の声
                </a>
                <a className={s.header_accordion_link} href={URL.COURSE_INTERVIEWS}>
                    ゴルフ場インタビュー
                </a>
                <HeaderAccordionGroup
                    title='住地ゴルフについて'
                    open={openGroup === 'about'}
                    onToggle={() => setOpenGroup(openGroup === 'about' ? null : 'about')}
                >
                    <a className={s.header_accordion_child_link} href={URL.COMPANY}>
                        会社情報
                    </a>
                    <a className={s.header_accordion_child_link} href={URL.SERVICE}>
                        事業紹介
                    </a>
                </HeaderAccordionGroup>
                <a className={s.header_accordion_link} href={URL.CLUB}>
                    住地倶楽部
                </a>
                <div className={s.inquiry_button}>
                    <a href={contactUrl}>
                        <OperatorSVGIcon className={s.operator_icon} />
                        お問合せ
                    </a>
                </div>
                {isBusinessTime() && (
                    <div className={s.inquiry_tel}>
                        <div className={s.inquiry_tel_box}>
                            <p>お電話でのお問合せ</p>
                            <a href='tel:0120-18-0072'>
                                <FreedialSVGIcon className={s.freedial_icon} bg_fill='#000' front_fill='#fff' />
                                0120-18-0072
                            </a>
                        </div>
                    </div>
                )}
                <div className={s.line_inquiry}>
                    <LineInquiry />
                </div>
            </div>
        </>
    );
};

interface HeaderAccordionGroupProps {
    title: string;
    open: boolean;
    onToggle: () => void;
    children: React.ReactNode;
}
const HeaderAccordionGroup = (props: HeaderAccordionGroupProps) => {
    return (
        <div className={s.header_accordion_group}>
            <button
                type='button'
                className={s.header_accordion_group_title}
                onClick={props.onToggle}
                aria-expanded={props.open}
            >
                <p className={s.header_accordion_group_title_text}>{props.title}</p>
                <div className={s.header_accordion_group_icon}>
                    <PlusMinus class={s.icon} type={props.open ? 'minus' : 'plus'} />
                </div>
            </button>
            <div className={`${s.header_accordion_group_children} ${props.open ? s.open : ''}`}>
                {props.open ? props.children : null}
            </div>
        </div>
    );
};
